export class SC_QCStatuses {
    static readonly ANY = 0;
    static readonly NEEDS_ISSUING = 1;
    static readonly AWAITING = 2;
    static readonly REQUIRES_REVIEW = 3;
    static readonly REQUIRES_UPLOAD = 4;
    static readonly COMPLETE = 5;

    constructor(private flagReport: number = SC_QCStatuses.ANY) { }

    static fromAPI(apiValue: number): SC_QCStatuses {
        switch (apiValue) {
            case SC_QCStatuses.NEEDS_ISSUING:
                return new SC_QCStatuses(SC_QCStatuses.NEEDS_ISSUING);
            case SC_QCStatuses.AWAITING:
                return new SC_QCStatuses(SC_QCStatuses.AWAITING);
            case SC_QCStatuses.REQUIRES_REVIEW:
                return new SC_QCStatuses(SC_QCStatuses.REQUIRES_REVIEW);
            case SC_QCStatuses.REQUIRES_UPLOAD:
                return new SC_QCStatuses(SC_QCStatuses.REQUIRES_UPLOAD);
            case SC_QCStatuses.COMPLETE:
                return new SC_QCStatuses(SC_QCStatuses.COMPLETE);
            default:
                return new SC_QCStatuses();
        }
    }

    is(type: number): boolean {
        return this.flagReport === type;
    }

    toAPI(): number {
        return this.flagReport;
    }

    clone(): SC_QCStatuses {
        return new SC_QCStatuses(this.flagReport);
    }

    static readonly qcStatuses = [
        { key: SC_QCStatuses.ANY, display: "Any" },
        { key: SC_QCStatuses.NEEDS_ISSUING, display: "Not Issued" },
        { key: SC_QCStatuses.AWAITING, display: "Awaiting" },
        { key: SC_QCStatuses.REQUIRES_REVIEW, display: "Review Needed" },
        { key: SC_QCStatuses.REQUIRES_UPLOAD, display: "Upload Needed" },
        { key: SC_QCStatuses.COMPLETE, display: "Completed" },
    ];
}
